import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Beef, Mail, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center px-4 relative z-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-red-600 flex items-center justify-center"><Beef className="w-5 h-5 text-white" /></div>
          <span className="font-display font-extrabold text-xl">CarnesWork</span>
        </Link>
        <div className="cw-card p-8 anim-fade-up">
          {sent ? (
            <>
              <Mail className="w-10 h-10 text-emerald-400 mb-3" />
              <h1 className="text-2xl font-display font-bold mb-2">Verifique seu email</h1>
              <p className="text-sm text-zinc-400 mb-6">
                Se <strong className="text-white">{email}</strong> tiver conta no CarnesWork, você receberá um link para redefinir sua senha em instantes. O link vale por 1 hora.
              </p>
              <Link to="/login" className="cw-btn-outline w-full inline-block text-center">Voltar ao login</Link>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-display font-bold mb-1">Esqueci a senha</h1>
              <p className="text-sm text-zinc-400 mb-6">Digite seu email e enviaremos um link de redefinição.</p>
              <form onSubmit={submit} className="space-y-4">
                <input required type="email" className="cw-input" data-testid="input-forgot-email"
                       value={email} onChange={e => setEmail(e.target.value)} placeholder="voce@email.com" />
                <button type="submit" disabled={loading} className="cw-btn-primary w-full flex items-center justify-center gap-2" data-testid="btn-forgot-submit">
                  {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Enviando…</> : "Enviar link"}
                </button>
              </form>
              <p className="text-sm text-zinc-400 text-center mt-6">
                Lembrou? <Link to="/login" className="text-red-500 font-semibold">Voltar ao login</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
